import type { PropsWithChildren } from 'react'

import { BudgetCategoryCardAttributesRow } from '../BudgetCategoryCardAttributesRow'
import { BudgetCategoryCardAttributesStyled } from './styles/BudgetCategoryCardAttributesStyled'

export interface IBudgetCategoryCardAttributesProps {}

export const BudgetCategoryCardAttributes = ({
  children,
}: PropsWithChildren<IBudgetCategoryCardAttributesProps>) => {
  return (
    <BudgetCategoryCardAttributesStyled>
      <table>{children}</table>
    </BudgetCategoryCardAttributesStyled>
  )
}

BudgetCategoryCardAttributes.displayName = 'BudgetCategoryCardAttributes'
BudgetCategoryCardAttributes.Row = BudgetCategoryCardAttributesRow
